/* Fiche Lune : reprend la date et le lieu calculés sur l'accueil (?date=AAAA-MM-JJ&lieu=Ville).
   Les champs sont créés par l'app VO Product Options après le chargement : on attend qu'ils existent, on ne remplit que s'ils sont vides. */
(function () {
  const q = new URLSearchParams(location.search), iso = q.get('date'), lieu = q.get('lieu');
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return;
  const CHAMPS = { "properties[Date de l'événement (pour le calcul lunaire)]": iso.split('-').reverse().join('/'), "properties[Lieu de l'événement (Ville/Pays)]": lieu || '' };
  const remplir = () => {
    let fait = 0;
    for (const [nom, valeur] of Object.entries(CHAMPS)) {
      const c = document.querySelector(`input[name="${CSS.escape(nom)}"]`);
      if (!c) continue;
      if (!c.value && valeur) { c.value = valeur; c.dispatchEvent(new Event('input', { bubbles: true })); c.dispatchEvent(new Event('change', { bubbles: true })); }
      fait++;
    }
    return fait === Object.keys(CHAMPS).length;
  };
  if (remplir()) return;
  const obs = new MutationObserver(() => { if (remplir()) obs.disconnect(); });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), 15000);
})();
